<div class="accordion" [class.expanded]="isExpanded()">
  <div class="title">
    <app-ui-section-title
      [title]="title()"
      [titleLevel]="'h3'"
      [subtitle]="subtitle()"
      [actionButtons]="actionButtons()"
    ></app-ui-section-title>
  </div>

  @if (isExpanded()) {
    <div class="accordion__content">
      <ng-content></ng-content>
    </div>
  }
</div>
